// extracted by mini-css-extract-plugin
export var checkboxInputRow = "C_tJ";
export var checkboxInputColumn = "C_tK";
export var inputOptionRow = "C_pT";
export var inputOptionColumn = "C_pV";